import { api_GET, api_POST, api_PUT } from "./_api.js";

const modelosEmail_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ModelosEmail/getlist`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ModelosEmail/getitem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (modeloEmail) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ModelosEmail`, modeloEmail)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (modeloEmail) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`ModelosEmail`, modeloEmail)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default modelosEmail_api;
